export const comments_3319762 = {"data":{"data":[],"links":{}}}